<script>
export default {
  name: "stat-cards",
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    blurred: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div class="stat-grid" :class="{ 'is-loading': loading }">
    <div class="stat-card" v-for="card in cards" :key="card.description">
      <div class="stat-number" :class="{ 'is-blurred': blurred }" v-html="card.number"></div>
      <div class="stat-title">
        {{ card.description }}
        <span
          v-if="card.tooltip"
          class="stat-info"
          tabindex="0"
          aria-label="How this is calculated"
          v-b-tooltip.hover.top="card.tooltip"
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
        </span>
      </div>
      <div class="stat-subtitle">{{ card.subTitle }}</div>
    </div>
  </div>
</template>

<style scoped>
.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  transition: opacity 150ms ease;
}
@media (max-width: 1280px) {
  .stat-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 991px) {
  .stat-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 575px) {
  .stat-grid {
    grid-template-columns: 1fr;
  }
}
.stat-grid.is-loading {
  opacity: 0.45;
  pointer-events: none;
}
.stat-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
}
.stat-number {
  font-size: 32px;
  line-height: 38px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.01em;
}
.stat-number.is-blurred {
  filter: blur(9px);
  user-select: none;
  pointer-events: none;
}
.stat-title {
  margin-top: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
}
.stat-info {
  display: inline-flex;
  align-items: center;
  color: #9ca3af;
  cursor: help;
  transition: color 120ms ease;
}
.stat-info:hover,
.stat-info:focus {
  color: #4b5563;
  outline: none;
}
.stat-info svg {
  display: block;
}
.stat-subtitle {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
}
</style>
